import styled, { css } from 'styled-components'
import { Color } from 'root-constants'
import selectedPriceBadgeUrl from 'assets/images/selected-price-badge.svg'
import priceBadgeUrl from 'assets/images/price-badge.svg'

type TProps = {
  isSelected: boolean
  isDefault?: boolean
}

const commonPriceStyles = css`
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  text-align: right;
  color: #898b95;
`

export const StyledSubscriptionItemV2 = {
  Wrapper: styled.div<TProps>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding: 16px 12px;
    background: ${Color.WHITE};
    border-radius: ${({ isDefault }) =>
      `${isDefault ? '0 0 20px 20px' : '20px'}`};
  `,
  Content: styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: end;
    flex: 1;

    &:last-child {
      justify-content: flex-end;
    }
  `,
  SelectionOption: styled.div<TProps>`
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    align-self: center;
    ${({ isSelected }) =>
      !isSelected &&
      `
       min-width: 24px;
       height: 24px;
       margin-right: 6px;
       border: 1px solid #81848c;
        `};

    svg {
      ${({ isSelected }) =>
        !isSelected &&
        `
        display: none;
        `};
    }
  `,
  MostPopularBadge: styled.div`
    width: 100%;
    height: 26px;
    padding: 4px 12px;
    border-radius: 20px 20px 0 0;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    text-align: center;
    background: ${Color.GRADIENT};
    color: ${Color.WHITE};
  `,
  PlanContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding-left: 12px;
  `,
  PlanPeriod: styled.span<TProps>`
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    text-transform: uppercase;
    color: ${({ isSelected }) => (isSelected ? Color.DARK : '#898b95')};
  `,
  PriceContainer: styled.div`
    display: flex;
    width: 100%;
  `,
  PreviousPrice: styled.span`
    ${commonPriceStyles};
    opacity: 0.9;
    padding-right: 8px;
    text-decoration: line-through;
  `,
  PreviousPriceCrossed: styled.span`
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #898b95;
    padding-right: 10px;
    text-decoration: line-through;
    text-decoration-color: #e65c3e;
  `,
  CurrentPrice: styled.span`
    ${commonPriceStyles};
  `,
  CustomPrice: styled.div<TProps>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    min-width: 84px;
    min-height: 48px;
    padding-top: 8px;
    transition: background 0.3s ease-out;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${priceBadgeUrl});
    background-size: 100%;

    ${({ isSelected }) =>
      isSelected &&
      `
        background-image: url(${selectedPriceBadgeUrl});
    `};

    span {
      color: ${({ isSelected }) => (isSelected ? Color.WHITE : '#898b95')};
    }
  `,
  PriceValue: styled.span`
    font-weight: 700;
    font-size: 30px;
    line-height: 30px;
  `,
  Period: styled.span`
    margin-right: 5px;
    font-weight: 400;
    font-size: 10px;
    line-height: 10px;
  `,
  Currency: styled.span`
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
  `,
  DecimalPrice: styled.div`
    display: flex;
    flex-direction: column;
    font-weight: 700;
    font-size: 15px;
    line-height: 15px;
  `,
}
